module.exports = __webpack_public_path__ + "media/3.34c4ad13.mp3";